import { TTab } from "../index.tsx";
import * as S from "./styles.ts";

interface ITabLabelsProps {
  tabs: TTab[];
  activeTab: string | number;
  onChange: (tab: string | number) => void;
}

const TabLabels = ({ tabs, activeTab, onChange }: ITabLabelsProps) => {
  return (
    <S.TabLabelsWrapper>
      {tabs.map((tab) => (
        <S.TabLabel
          key={tab.key}
          $active={activeTab === tab.key}
          onClick={() => onChange(tab.key as any)}
        >
          {tab.disabled ? undefined : tab.label.startContent}
          <S.TabLabelValue as="h3">
            {tab.disabled ? undefined : tab.label.value}
          </S.TabLabelValue>
          {tab.disabled ? undefined : tab.label.endContent}
        </S.TabLabel>
      ))}
    </S.TabLabelsWrapper>
  );
};

export default TabLabels;
